import { createContext } from 'react';

import {
  CheckoutAPIContextProps,
  CheckoutStateContextProps,
} from '~/types/checkout';

export const CheckoutStateContext = createContext<CheckoutStateContextProps>(
  {} as CheckoutStateContextProps,
);
export const CheckoutAPIContext = createContext<CheckoutAPIContextProps>(
  {} as CheckoutAPIContextProps,
);
